<template>
	<modals-header v-bind="$attrs">
		<svg-exclamation-triangle />
		Confirmation Required
	</modals-header>
</template>
<script>
export default {
	inheritAttrs: false,
};
</script>
